import React from 'react';
import { TroubleShootingTextWrapper } from '../AddedPrinter';
import Heading from '~ComponentsImproved/Typography/Heading';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';
import { useI18n, useSelector } from '~Hooks';
import { CountryCode } from '~Types';

// {new-country-onboarding} Add support phone number here
const SUPPORT_PHONE: Record<CountryCode, string> = {
  SE: '+46 10 204 02 04',
  ES: '+34 919 03 73 44',
  NO: '+47 22 04 64 90',
  GB: '+44 20 8098 2079',
  TR: '+46 10 204 02 04',
  DK: '+46 10 204 02 04',
  AE: '+46 10 204 02 04',
};

const ContactSupport = () => {
  const { i18n } = useI18n();
  const country = useSelector((state) => state.country);

  return (
    <div>
      <TroubleShootingTextWrapper>
        <Heading level={1} color="#fff" bottom={16}>
          {i18n('Printer.TS.ContactSupport')}
        </Heading>
        <Paragraph level={2} color="var(--colorBlueGray200)" bottom={24}>
          {i18n('Printer.TS.ContactSupport.Text')}
        </Paragraph>
        <Paragraph level={1} color="var(--colorBlueGray200)">
          {SUPPORT_PHONE[country ?? 'SE']}
        </Paragraph>
      </TroubleShootingTextWrapper>
    </div>
  );
};

export default ContactSupport;
